import { OrganizationsState } from "@idw-types/state/organizations-state";
import { getOrganizationsState } from "@redux/selectors/root-selectors";
import { createSelector } from "reselect";

export const getOrganizationsDataState = createSelector(getOrganizationsState, (state: OrganizationsState) => {
    return {
        isLoadingAxnCompanies: state.organizations.isLoading,
        axnCompanies: state.organizations.organizations
    };
});